import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-background text-foreground"
    >
      <div className="px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="/assets/keppel-logo.png"
            alt="Keppel Immobilien"
            className="h-20 w-auto"
          />
          <p className="mt-6 text-sm leading-relaxed text-muted-foreground max-w-sm">
            Inhabergeführtes Familienunternehmen für die behutsame Sanierung und
            langfristige Verwaltung kleiner Mehrfamilienhäuser in Oberfranken.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-primary mb-4">Navigation</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/ueber-uns" className="hover:text-primary">Über uns</Link></li>
            <li><Link to="/portfolio" className="hover:text-primary">Suchprofil</Link></li>
            <li><Link to="/verkaufen" className="hover:text-primary">Haus verkaufen</Link></li>
            <li><Link to="/partner" className="hover:text-primary">Partner</Link></li>
            <li><Link to="/bewerbung" className="hover:text-primary">Mietbewerbung</Link></li>
            <li><Link to="/referenzen" className="hover:text-primary">Portfolio</Link></li>
            <li><Link to="/kontakt" className="hover:text-primary">Kontakt</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.2em] text-primary mb-4">Kontakt</div>
          <div className="space-y-3 text-sm">
            <div>
              <div className="text-foreground">Für Mieter</div>
              <a href="mailto:post@keppel-immobilien.de" className="text-muted-foreground hover:text-primary block">
                post@keppel-immobilien.de
              </a>
              <a href="tel:+4922164009085" className="text-muted-foreground hover:text-primary block">
                0221 – 64 00 90 85
              </a>
            </div>
            <div>
              <div className="text-foreground">Für Makler & Handwerker</div>
              <a href="mailto:objekte@keppel-immobilien.de" className="text-muted-foreground hover:text-primary block">
                objekte@keppel-immobilien.de
              </a>
              <a href="tel:+4922164009081" className="text-muted-foreground hover:text-primary block">
                0221 – 64 00 90 81
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} Keppel Immobilien · Alle Rechte vorbehalten</div>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-primary">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-primary">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
